module.exports = __webpack_public_path__ + "img/incein-l-circle-2.3e624084.svg";